const lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
const long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;

function isLatLng(str) {
  if (typeof str !== 'string' && !str?.includes(',')) {
    return false;
  }

  const pair = str.split(',');

  return lat.test(pair[0]) && long.test(pair[1]);
}

export default isLatLng;
